import { useCallback, useEffect, useState } from 'react';
import { licenseAPI } from '../services/api';

const useLicenseUsage = ({ universityId, enabled = true } = {}) => {
  const [usage, setUsage] = useState(null);
  const [loading, setLoading] = useState(Boolean(enabled));
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    if (!enabled || !universityId) {
      return;
    }

    try {
      setLoading(true);
      const response = await licenseAPI.getUsage(universityId);
      setUsage(response.data);
      setError(null);
    } catch (err) {
      console.error('Failed to load licence usage', err);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [enabled, universityId]);

  useEffect(() => {
    if (enabled && universityId) {
      refresh();
    } else {
      setLoading(false);
    }
  }, [enabled, universityId, refresh]);

  return {
    usage,
    loading,
    error,
    refresh,
  };
};

export default useLicenseUsage;
